import greenClock from "../assets/images/green-clock.png";
import redClock from "../assets/images/red-clock.png";
import calender from "../assets/images/calender.png";
import { useRestaurant } from "../context/RestaurantContext";
import { formatDateRange } from "../utils/analytics";

const FoodPreparationTime = () => {
  const { restaurantProfile, dashboardData } = useRestaurant();
  const analytics = dashboardData?.analytics;
  const prepTime = restaurantProfile?.avgPreparationTime || 0;
  const dateRange = formatDateRange(
    analytics?.period?.startDate,
    analytics?.period?.endDate
  );
  const completionRate = Math.round(analytics?.summary?.completionRate || 0);
  const delivered = analytics?.summary?.deliveredOrders || 0;
  const total = analytics?.summary?.totalOrders || 0;
  const onTime = Math.round((delivered * completionRate) / 100) || delivered;
  const delayed = Math.max(0, total - onTime);

  return (
    <div className="p-4 sm:p-5 max-w-7xl mx-auto">
      <div className="flex items-center justify-between">
        <h3 className="text-[#050505] dark:text-gray-200 font-Urbanist text-base sm:text-[18px] font-semibold">
          Food Preparation time
        </h3>
        <span className="text-[#FF8A00] dark:text-orange-400 font-Urbanist text-base sm:text-[18px] font-semibold">
          {prepTime ? `${prepTime} Mins` : "--"}
        </span>
      </div>
      <p className="text-[#FF8A00] dark:text-orange-400 font-Urbanist text-xs sm:text-[12px] font-normal mb-4 flex items-center gap-2">
        {dateRange ? `for ${dateRange}` : "Average kitchen preparation time"}
        <img src={calender} alt="Calendar" className="w-4 h-4 dark:invert" />
      </p>

      <div className="bg-[#FAFAFA] dark:bg-gray-800 rounded-2xl border border-gray-200 dark:border-gray-700 p-4 sm:p-[15px] transition-colors">
        <div className="flex items-center justify-between pb-3 border-b dark:border-gray-700">
          <div>
            <h4 className="text-[#050505] dark:text-gray-200 font-Urbanist text-sm sm:text-[16px] font-semibold mb-1">
              {completionRate ? `${completionRate}% Orders completed` : "Order completion"}
            </h4>
            <p className="text-[#FF8A00] dark:text-orange-400 font-Urbanist text-xs sm:text-[12px] font-normal">
              {dateRange ? `for ${dateRange}` : "for selected period"}
            </p>
          </div>
        </div>

        <div className="flex flex-row justify-between items-stretch gap-4 sm:gap-8 my-[10px] w-full">
          <div className="flex items-center gap-2 flex-1 px-4 sm:px-[20px] py-[10px] bg-[#ECECEC] dark:bg-gray-700 rounded-lg">
            <img src={greenClock} alt="On time" className="h-[17px] w-[17px]" />
            <span className="text-[#050505] dark:text-gray-200 font-Urbanist text-sm sm:text-[15px] font-medium">
              Completed
            </span>
            <span className="text-[#050505] dark:text-gray-200 font-Urbanist text-sm sm:text-[15px] font-medium ml-auto">
              {onTime}/{total || 0}
            </span>
          </div>
          <div className="flex items-center gap-2 flex-1 px-4 sm:px-[20px] py-[10px] bg-[#ECECEC] dark:bg-gray-700 rounded-lg">
            <img src={redClock} alt="Delayed" className="h-[17px] w-[17px]" />
            <span className="text-[#050505] dark:text-gray-200 font-Urbanist text-sm sm:text-[15px] font-medium">
              Other
            </span>
            <span className="text-[#050505] dark:text-gray-200 font-Urbanist text-sm sm:text-[15px] font-medium ml-auto">
              {delayed}/{total || 0}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FoodPreparationTime;
